var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-f02e98f8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "mx-10 py-5 flex items-center justify-between"
};
var _hoisted_2 = { class: "text-lg" };
var _hoisted_3 = { key: 2 };
var _hoisted_4 = { key: 0 };
var _hoisted_5 = { class: "gap-y-4" };
var _hoisted_6 = { key: 1 };
var _hoisted_7 = {
    key: 0,
    class: "gap-y-4"
};
var _hoisted_8 = {
    key: 1,
    class: "gap-y-4"
};
var _hoisted_9 = {
    key: 2,
    class: "gap-y-4"
};
var _hoisted_10 = { class: "text-base opacity-50 hover:opacity-70" };
import EIcon from '@common/ui/EIcon.vue';
import { useTabs } from '@common/ui/ETabs/useTabs';
import ETabs from '@common/ui/ETabs/ETabs.vue';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import ECircleMark from '@common/ui/ECircleMark/ECircleMark.vue';
import NotificationsList from '@common/components/Notifications/components/NotificationsList.vue';
import { useSetAllReadedMutation, GetAllNotificationsDocument, useGetAllNotificationsQuery, NotificationGroupEnum } from '@common/graphql/operations';
import Auth from '@common/modules/auth';
import ETooltip from '@common/ui/ETooltip.vue';
import EmptyNotifications from '@common/components/Notifications/components/EmptyNotifications.vue';
import EScrollbar from '@common/ui/EScrollbar.vue';
import { isMobile } from '@common/utils/Crossbrowser';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsPanel',
    setup: function (__props) {
        var t = useI18n().t;
        var isHovering = ref(false);
        var isShowReaded = ref(false);
        var shouldLoadMore = ref(true);
        var isStudent = computed(function () { return Auth.isStudentUser(); });
        var allUnreaded = computed(function () { var _a, _b; return (_b = (_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notifications.filter(function (item) { return !item.viewed; })) !== null && _b !== void 0 ? _b : []; });
        var allReaded = computed(function () { var _a, _b; return (_b = (_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notifications.filter(function (item) { return item.viewed; })) !== null && _b !== void 0 ? _b : []; });
        var allNewCount = computed(function () { var _a; return ((_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notificationsCount.reduce(function (acc, currentItem) { return acc + currentItem.countUnread; }, 0)) || 0; });
        var isQueryEnabled = computed(function () { return !!Auth.getUser(); });
        var _a = useGetAllNotificationsQuery(function () { return ({
            pagination: {
                skip: 0,
                take: 20,
            },
        }); }, {
            enabled: isQueryEnabled
        }), notificationsResult = _a.result, fetchMore = _a.fetchMore, refetch = _a.refetch;
        var setAllReaded = useSetAllReadedMutation(function () { return ({
            update: function (cache) {
                cache.updateQuery({
                    query: GetAllNotificationsDocument,
                    variables: {
                        pagination: {
                            skip: 0,
                            take: 20
                        }
                    },
                }, function (data) {
                    var _a, _b;
                    return ({
                        notifications: (_a = data === null || data === void 0 ? void 0 : data.notifications.map(function (item) { return (__assign(__assign({}, item), { viewed: true })); })) !== null && _a !== void 0 ? _a : [],
                        notificationsCount: (_b = data === null || data === void 0 ? void 0 : data.notificationsCount.map(function (item) { return (__assign(__assign({}, item), { countUnread: 0 })); })) !== null && _b !== void 0 ? _b : []
                    });
                });
            }
        }); }).mutate;
        watch(allNewCount, function (v) {
            if (v === 0)
                return;
            isShowReaded.value = true;
        });
        var tasksUnreaded = computed(function () { var _a, _b; return (_b = (_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notifications.filter(function (item) { return item.group === NotificationGroupEnum.Homeworks && !item.viewed; })) !== null && _b !== void 0 ? _b : []; });
        var tasksReaded = computed(function () { var _a, _b; return (_b = (_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notifications.filter(function (item) { return item.group === NotificationGroupEnum.Homeworks && item.viewed; })) !== null && _b !== void 0 ? _b : []; });
        var tasksCount = computed(function () { var _a, _b; return ((_b = (_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notificationsCount.find(function (item) { return item.group === NotificationGroupEnum.Homeworks; })) === null || _b === void 0 ? void 0 : _b.countUnread) || 0; });
        var paymentsUnreaded = computed(function () { var _a, _b; return (_b = (_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notifications.filter(function (item) { return item.group === NotificationGroupEnum.Billing && !item.viewed; })) !== null && _b !== void 0 ? _b : []; });
        var paymentsReaded = computed(function () { var _a, _b; return (_b = (_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notifications.filter(function (item) { return item.group === NotificationGroupEnum.Billing && item.viewed; })) !== null && _b !== void 0 ? _b : []; });
        var paymentsCount = computed(function () { var _a, _b; return ((_b = (_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notificationsCount.find(function (item) { return item.group === NotificationGroupEnum.Billing; })) === null || _b === void 0 ? void 0 : _b.countUnread) || 0; });
        var showMarkAllRead = computed(function () { return allUnreaded.value.length > 0; });
        var isShowEmpty = computed(function () { return allUnreaded.value.length === 0 && !isShowReaded.value; });
        var isShowAllread = computed(function () { return showMarkAllRead.value && !isMobile(); });
        var showReaded = function () {
            isShowReaded.value = true;
        };
        var loadMore = function () {
            var _a, _b;
            if (!shouldLoadMore.value)
                return;
            fetchMore({
                variables: {
                    pagination: {
                        skip: ((_a = notificationsResult.value) === null || _a === void 0 ? void 0 : _a.notifications.length) || 0,
                        take: (((_b = notificationsResult.value) === null || _b === void 0 ? void 0 : _b.notifications.length) || 0) + 20,
                    }
                },
                updateQuery: function (previousQueryResult, _a) {
                    var fetchMoreResult = _a.fetchMoreResult;
                    if (fetchMoreResult.notifications.length < 20) {
                        shouldLoadMore.value = false;
                    }
                    var previousNotifications = previousQueryResult.notifications;
                    var newNotifications = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.notifications;
                    var newNotificationsCount = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.notificationsCount;
                    return {
                        notifications: __spreadArray(__spreadArray([], __read(previousNotifications), false), __read((newNotifications || [])), false),
                        notificationsCount: __spreadArray([], __read((newNotificationsCount || [])), false)
                    };
                },
            });
        };
        var _b = useTabs('all', function () { return [
            {
                name: t('tabs.all'),
                value: 'all',
                count: allNewCount.value,
            },
            {
                name: t('tabs.tasks'),
                value: 'tasks',
                count: tasksCount.value,
            },
            {
                name: t('tabs.payments'),
                value: 'payments',
                count: paymentsCount.value,
            }
        ]; }), activeTab = _b.activeTab, tabs = _b.tabs;
        var mobileApp = isMobile();
        onMounted(function () {
            if (mobileApp) {
                document.body.style.overflow = 'hidden';
            }
        });
        onUnmounted(function () {
            if (mobileApp) {
                document.body.style.overflow = '';
            }
        });
        return function (_ctx, _cache) {
            var _component_e_link = _resolveComponent("e-link");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([showMarkAllRead.value && 'pb-5', "notifications-panel"])
            }, [
                (!_unref(isMobile)())
                    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
                        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('notifications.header')), 1),
                        _createVNode(ETooltip, {
                            "tooltip-text": _unref(t)('notifications.settingsTooltip'),
                            theme: "dark",
                            trigger: "hover",
                            fullwidth: ""
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_e_link, {
                                    "href-to": { name: 'profileNotifications' },
                                    class: "group flex items-center",
                                    type: "transparent"
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(EIcon, {
                                            class: "opacity-30 w-[18px] h-[18px] group-hover:opacity-80 duration-200",
                                            icon: "notifications/notification-settings"
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }, 8, ["tooltip-text"])
                    ]))
                    : _createCommentVNode("", true),
                (isShowEmpty.value)
                    ? (_openBlock(), _createBlock(EmptyNotifications, {
                        key: 1,
                        onShowReaded: showReaded
                    }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (isStudent.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(EScrollbar, {
                                    options: {
                                        wheelPropagation: false
                                    },
                                    class: "scrollbar",
                                    onPsYReachEnd: loadMore
                                }, {
                                    default: _withCtx(function () { return [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createVNode(NotificationsList, { notifications: allUnreaded.value }, null, 8, ["notifications"]),
                                            _createVNode(NotificationsList, {
                                                class: _normalizeClass(allUnreaded.value.length > 0 && 'mt-5'),
                                                notifications: allReaded.value,
                                                title: _unref(t)('notifications.read')
                                            }, null, 8, ["class", "notifications", "title"])
                                        ])
                                    ]; }),
                                    _: 1
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(ETabs, {
                                    modelValue: _unref(activeTab),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(activeTab) ? (activeTab).value = $event : null); }),
                                    tabs: _unref(tabs),
                                    class: "notifications-panel__tabs",
                                    type: "secondary"
                                }, null, 8, ["modelValue", "tabs"]),
                                (_unref(activeTab) === 'all')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createVNode(EScrollbar, {
                                            options: {
                                                wheelPropagation: false
                                            },
                                            class: "scrollbar",
                                            onPsYReachEnd: loadMore
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", null, [
                                                    _createVNode(NotificationsList, { notifications: allUnreaded.value }, null, 8, ["notifications"]),
                                                    _createVNode(NotificationsList, {
                                                        class: _normalizeClass(allUnreaded.value.length > 0 && 'mt-5'),
                                                        notifications: allReaded.value,
                                                        title: _unref(t)('notifications.read')
                                                    }, null, 8, ["class", "notifications", "title"])
                                                ])
                                            ]; }),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(activeTab) === 'tasks')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createVNode(EScrollbar, {
                                            options: {
                                                wheelPropagation: false
                                            },
                                            class: "scrollbar",
                                            onPsYReachEnd: loadMore
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", null, [
                                                    _createVNode(NotificationsList, { notifications: tasksUnreaded.value }, null, 8, ["notifications"]),
                                                    _createVNode(NotificationsList, {
                                                        class: _normalizeClass(tasksUnreaded.value.length > 0 && 'mt-5'),
                                                        notifications: tasksReaded.value,
                                                        title: _unref(t)('notifications.read')
                                                    }, null, 8, ["class", "notifications", "title"])
                                                ])
                                            ]; }),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(activeTab) === 'payments')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createVNode(EScrollbar, {
                                            options: {
                                                wheelPropagation: false
                                            },
                                            class: "scrollbar",
                                            onPsYReachEnd: loadMore
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("div", null, [
                                                    _createVNode(NotificationsList, { notifications: paymentsUnreaded.value }, null, 8, ["notifications"]),
                                                    _createVNode(NotificationsList, {
                                                        class: _normalizeClass(paymentsUnreaded.value.length > 0 && 'mt-5'),
                                                        notifications: paymentsReaded.value,
                                                        title: _unref(t)('notifications.read')
                                                    }, null, 8, ["class", "notifications", "title"])
                                                ])
                                            ]; }),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ])),
                        (isShowAllread.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "mx-auto bg-white py-2.5 xs:py-0 xs:mt-7 w-full flex items-center justify-center gap-x-2.5 cursor-pointer",
                                onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(setAllReaded)()); }),
                                onMouseleave: _cache[2] || (_cache[2] = function ($event) { return (isHovering.value = false); }),
                                onMouseover: _cache[3] || (_cache[3] = function ($event) { return (isHovering.value = true); })
                            }, [
                                _createVNode(ECircleMark, {
                                    "is-hovering": isHovering.value,
                                    theme: "gray"
                                }, null, 8, ["is-hovering"]),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('notifications.markAllRead')), 1)
                            ], 32))
                            : _createCommentVNode("", true)
                    ]))
            ], 2));
        };
    }
});
